import a from "classnames";
import { createElement as l } from "react";
const n = ({ as: o, children: s, className: m, variant: e, weight: t, ...r }) => l(
  o,
  {
    className: a(m, { [e]: !!e }),
    style: t ? { fontWeight: t } : void 0,
    ...r
  },
  s
);
export {
  n as default
};
